import React, { FC } from 'react';
import { Badge, UniversalCta } from '@/components';
import { TypeSubscriberShopFamilyPageData } from '@/pages/[locale]/account/subscriber-shop/family';
import generateTranslationsObject from '@/utils/translations/generateTranslationObject';
import { TypeSubscriberShopFamilyFields } from '@/core/generated-types';
import { TypeSubscriberShopPageTranslations } from '@/utils/translations/types/TypeSubscriberShopPageTranslations';
import dayjs from 'dayjs';
interface SubscriberShopFamilyProps extends TypeSubscriberShopFamilyFields {
  data: TypeSubscriberShopFamilyPageData;
}

const SubscriberShopFamily: FC<SubscriberShopFamilyProps> = ({
  data,
  translations,
  playKitSubscriberBadge,
  addAChildCta,
  subscriberShopCta,
}) => {
  const { subscriptionMap, children } = data;

  const t = generateTranslationsObject(
    translations.fields,
  ) as TypeSubscriberShopPageTranslations;

  return (
    <div
      data-testid="sub-shop-family-profile"
      className="max-auto mx-auto max-w-[600px] px-6"
    >
      {children.map((child, i) => {
        const { name, birthday, uuid } = child;
        const hasSubscription = subscriptionMap[uuid];
        const formattedBirthday = birthday
          ? dayjs(birthday).format('MMMM DD, YYYY')
          : '';
        return (
          <div
            data-testid="family-profile-child-card"
            key={i}
            className="relative mb-6 flex flex-col justify-between gap-y-2 rounded-md p-7 shadow-md"
          >
            {hasSubscription ? (
              <div>
                <Badge {...playKitSubscriberBadge.fields} />
              </div>
            ) : null}
            <div>
              <strong>{t.nameLabel}:</strong> {name}
            </div>
            <div>
              <strong>{t.dateOfBirthLabel}:</strong> {formattedBirthday}
            </div>
          </div>
        );
      })}
      <UniversalCta
        link={addAChildCta}
        className="text-xl"
        queryString="?page_source=subscriber_shop_onboarding"
      />
      <div className="mx-auto my-10 text-center md:max-w-[360px]">
        <UniversalCta link={subscriberShopCta} />
      </div>
    </div>
  );
};

export default React.memo(SubscriberShopFamily);
